import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import './FichaProcedimentosSeguranca.css';

const DOC_NOME = 'Ficha de Procedimentos de Segurança';

const FichaProcedimentosSeguranca = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(true);
    const [opening, setOpening] = useState(false);

    useEffect(() => {
        fetchDoc();
    }, []);

    const fetchDoc = async () => {
        try {
            const res = await api.get('/trabalhadores/documentos-internos');
            const found = res.data.find(d => d.nome === DOC_NOME);
            setDoc(found || null);
        } catch (err) {
            console.error('Erro ao carregar FPS:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenPdf = async () => {
        if (!doc || opening) return;
        setOpening(true);
        try {
            const res = await api.get(`/trabalhadores/documentos-internos/${doc.id}/pdf`, {
                responseType: 'blob'
            });
            const blob = new Blob([res.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            // Navigate to blob URL — opens native iOS PDF viewer with full scroll + zoom
            window.location.href = url;
        } catch (err) {
            alert('Erro ao abrir documento.');
            setOpening(false);
        }
    };

    const handleBack = () => {
        navigate('/mobile-dashboard');
    };

    if (loading) {
        return (
            <div className="fps-page">
                <div className="fps-header">
                    <button className="fps-back-btn" onClick={handleBack}>← Voltar</button>
                    <h1>F. Proc. Segurança</h1>
                </div>
                <div className="fps-loading">A carregar...</div>
            </div>
        );
    }

    return (
        <div className="fps-page">
            <div className="fps-header">
                <button className="fps-back-btn" onClick={handleBack}>← Voltar</button>
                <h1>🦺 F. Proc. Segurança</h1>
            </div>

            <div className="fps-content">
                {doc ? (
                    <div className="fps-card">
                        <div className="fps-card-icon">🦺</div>
                        <div className="fps-card-title">{DOC_NOME}</div>
                        <div className="fps-card-meta">
                            Versão {doc.versao} · Atualizado em {new Date(doc.atualizado_em).toLocaleDateString('pt-PT')}
                        </div>
                        <button
                            className="fps-open-btn"
                            onClick={handleOpenPdf}
                            disabled={opening}
                        >
                            {opening ? 'A abrir...' : 'Abrir Documento'}
                        </button>
                    </div>
                ) : (
                    <div className="fps-empty">
                        <div className="fps-empty-icon">🦺</div>
                        <p>Documento ainda não carregado.</p>
                        <p className="fps-empty-hint">O administrador pode carregar o PDF nas Configurações da Empresa.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FichaProcedimentosSeguranca;
